import { TypedActionWithPayload } from '@/types/redux';
import { Seller } from '@/types/Seller';
import { SellerCatalogCounts } from '@/types/SellerCatalogCounts';

export type SellerResponseData = {
    sellerCatalogCounts: SellerCatalogCounts[];
    sellers: Seller[];
};

/**
 * @deprecated If using redux toolkit, use `fetchSellersByIds.pending` instead
 */
export const LOAD_SELLERS_REQUEST = 'la/domain/sellers/LOAD_REQUEST';
/**
 * @deprecated If using redux toolkit, use `fetchSellersByIds.pending` instead
 */
export type LoadSellersRequestAction = TypedActionWithPayload<typeof LOAD_SELLERS_REQUEST, number[]>;
/**
 * @deprecated If using redux toolkit, use `fetchSellersByIds.fulfilled` instead
 */
export const LOAD_SELLERS_SUCCESS = 'la/domain/sellers/LOAD_SUCCESS';
/**
 * @deprecated If using redux toolkit, use `fetchSellersByIds.fulfilled` instead
 */
export type LoadSellersSuccessAction = TypedActionWithPayload<
    typeof LOAD_SELLERS_SUCCESS,
    SellerResponseData,
    {
        actionTime: number;
        sellerIds: number[];
    }
>;
/**
 * @deprecated If using redux toolkit, use `fetchSellersByIds.rejected` instead
 */
export const LOAD_SELLERS_FAIL = 'la/domain/sellers/LOAD_FAIL';
/**
 * @deprecated If using redux toolkit, use `fetchSellersByIds.rejected` instead
 */
export type LoadSellersFailAction = TypedActionWithPayload<
    typeof LOAD_SELLERS_FAIL,
    Error | string,
    { sellerIds: number[] }
>;

export type SellerSlice = {
    byId: { [id: number]: Seller };
    loaded: { [id: number]: number };
    loadedSellers: boolean;
    loading: number[];
    loadingSellers: boolean;
};

export const defaultSellerSlice: SellerSlice = {
    byId: {},
    loaded: {},
    loadedSellers: false,
    loading: [],
    loadingSellers: false,
};
